import { atom } from "recoil";

export const pageNumber = atom({
  key: "1",
  default: "0",
});
